import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import Icon from '../Icon';
import Button from '../Button';
import { useTranslation } from 'react-i18next';

export default function ModalConfirmation(props) {
  const { isOpen, toggle, approve, header, body, loading } = props;
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className='km__c--modal-confirmation-header'>
        <Icon name='alert-octagon' color='#FF991F' /> <p>{header}</p>
      </div>
      <div className='km__c--modal-confirmation-body'>
        <p>{body}</p>
      </div>
      <div className='km__c--modal-confirmation-footer'>
        <Button
          type='secondary'
          onClick={toggle}
          label={t('ui.default.discard')}
          id='confirmation-dismiss'
          disabled={loading}
        />
        <Button
          type='primary'
          onClick={approve}
          label={t('ui.default.approve')}
          id='confirmation-approve'
          disabled={loading}
        />
      </div>
    </Modal>
  );
}
ModalConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  header: PropTypes.string,
  body: PropTypes.string,
  approve: PropTypes.func,
};
ModalConfirmation.defaultProps = {
  isOpen: false,
};
